import {
  Directive,
  ElementRef,
  Input,
  OnInit,
  SimpleChanges,
} from '@angular/core';

@Directive({
  selector: '[smartSmsRequestId]',
  standalone: true,
})
export class SmartSmsRequestIdDirective implements OnInit {
  @Input('smartSmsRequestId') requestId: any;
  requestIdElement: HTMLDivElement;
  constructor(private element: ElementRef<HTMLElement>) {}

  ngOnInit(): void {
    //this.element.nativeElement.className = this.getCssClassList();
    this.requestIdElement = document.createElement('div');
    this.requestIdElement.classList.add('request-id-card-container');
    this.requestIdElement = this.element.nativeElement.appendChild(
      this.requestIdElement
    );
    this.requestIdElement.innerHTML =
      '<span class="request-id-card">' + this.requestId.toString() + '</span>';
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.requestIdElement != null)
      this.requestIdElement.innerHTML =
        '<span class="request-id-card">' +
        this.requestId.toString() +
        '</span>';
  }
}
